import { Card } from "@/components/ui/card"
import { MotionDiv } from "@/lib/framer"

const loadingSteps = [
  "💰 Calculating costs...",
  "📅 Sending calendar invites...",
  "👕 Putting a shirt on...",
  "🛜 Checking Wi-Fi connection...",
  "🎤 Mic check, mic check, 1, 2...",
];

const containerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export function CalculatorLoading() {
  return (
    <Card className="border-muted bg-card/50 flex items-center justify-center p-6 backdrop-blur-sm sm:p-8 md:p-12">
      <MotionDiv
        className="text-muted-foreground mx-auto w-full max-w-lg space-y-4 font-medium"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {loadingSteps.map((step) => (
          <MotionDiv
            key={step}
            variants={itemVariants}
            className="flex w-full items-center justify-center gap-3 text-center text-base sm:text-lg md:text-xl"
          >
            <span className="min-w-[24px] text-center text-2xl" aria-hidden="true">
              {step.split(" ")[0]}
            </span>
            <span className="flex flex-1 items-center gap-2 text-left break-words whitespace-pre-line sm:whitespace-normal">
              {step.split(" ").slice(1).join(" ")}
            </span>
          </MotionDiv>
        ))}
      </MotionDiv>
    </Card>
  );
}
